<div *ngIf="dados" class="document-preview">
  <img src="assets/img/header_sg.jpg" class="doc-header-img" alt="Cabeçalho">

  <h2 class="doc-center">UNIVERSIDADE ESTADUAL DE CAMPINAS</h2>
  <h3 class="doc-center">{{ dados.dadosConcurso.nomeUnidade }}</h3>
  <h3 class="doc-center">EDITAL DE RESULTADO DA PROVA DE TÍTULOS</h3>
  <p class="doc-center"><strong>(Proc. nº {{ dados.dadosConcurso.processoSigad }})</strong></p>

  <app-texto-com-placeholders
    [texto]="dados.textoIntrodutorio"
    [campos]="campos"
    (camposChange)="onCamposChange($event)">
  </app-texto-com-placeholders>

  <table *ngIf="candidatos.length > 0" class="equal-cols">
    <thead>
      <tr>
        <th class="col-candidato">NÚMERO DE INSCRIÇÃO E NOME DO(A) CANDIDATO(A)</th>
        <th *ngFor="let ex of examinadores">Prof(a). Dr(a). {{ ex }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let cand of candidatos">
        <td class="col-candidato">{{ cand | uppercase }}</td>
        <td *ngFor="let ex of examinadores">{{ getNota(cand, ex) }}</td>
      </tr>
    </tbody>
  </table>

  <div class="doc-footer">
    <p>Campinas,
      <mat-form-field appearance="outline" class="inline-field">
        <mat-label>Data</mat-label>
        <input matInput [(ngModel)]="campos['dataDocumento']" (ngModelChange)="emitir()">
      </mat-form-field>.
    </p>
  </div>
</div>
